import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.user()) {
    return auth.user()?.idRol === 1 || auth.user()?.idRol === 2
      ? true
      : router.createUrlTree(['/login']);
  }

  return auth.loadSession().pipe(map((user) => {
    if (user && (user.idRol === 1 || user.idRol === 2)) {
      return true;
    }

    return router.createUrlTree(['/login']);
  }));
};
